export const ROUTES = {
	auth: {
		login: '/auth/login',
	},
	downloadApp: '/download-app',
	orders: '/orders',
	offers: '/offers',
	wallet: '/wallet',
	notifications: '/notifications',
	order: (orderId: string) => `/orders/${orderId}`,
	offer: (offerId: string) => `/offers/${offerId}`,
	profile: '/profile',
	profileData: '/profile/data',
	profileAddAccountPayment: '/profile/payment-ways/account',
	profileAddCardPayment: '/profile/payment-ways/card',
	profileAddSbpPayment: '/profile/payment-ways/sbp',
	profileGenerateCertificate: '/profile/certificate',
	profileGenerateReceipt: '/profile/receipt',
	profileTerms: '/profile/terms',
	profileDocuments: '/profile/documents',
	profileStatuses: '/profile/statuses',
	profileAutoReply: '/profile/auto-reply',
	registration: '/registration',
} as const;
